import React from "react";
import Utils from "@/utils/index";
import { Button, Slider, Select, Row, Col } from "antd";
import { ReactComponent as VideoIcon } from "@/assets/icons/video.svg";
import { ReactComponent as CloseIcon } from "@/assets/icons/close.svg";
import Process from "@/components/common/process/Process";
import { useTranslation } from "react-i18next";

import "@/assets/videoCompress.less";

const { Option } = Select;

const VideoCompressWorkContentRender = ({
  quality,
  frameRate,
  resolution,
  processText,
  resolutionList,
  submitting,
  videoCompressObj,
  handleSubmit,
  handleVideoObjClose,
  handleChangeResolution,
  handleChangeQuality,
  handleChangeFrameRate,
  cancelProcessCallBack,
}) => {
  const { t } = useTranslation(["videoCompress"]);
  const qulityMarks = {
    10: t("Small Size", { num: 10 }),
    100: t("High Quality", { num: 100 }),
  };
  const frameRateMarks = {
    5: "5 FPS",
  };
  frameRateMarks[videoCompressObj.frameRate] = videoCompressObj.frameRate + "FPS";
  const maxFrameRate = videoCompressObj.frameRate;
  return (
    <div className="work-cont-cont">
      <div className="work-cont-hd">
        <div style={{ display: "flex", alignItems: "center" }}>
          <VideoIcon />
          <span>{Utils.omissionString(Utils.getFileName(videoCompressObj.name), 5, 5)}</span>
          {videoCompressObj.uploadStatus ? <span>{(videoCompressObj.size / 1024 / 1024).toFixed(2)}MB</span> : null}
        </div>
        <CloseIcon style={{ cursor: "pointer" }} onClick={handleVideoObjClose} />
      </div>
      {submitting ? (
        <div className="work-cont-con" style={{ position: "relative", minHeight: 400 }}>
          <Process
            visible
            theme="dark"
            showProcessText
            hideCancelBtn
            processText={processText}
            hideCancelText
            cancelProcessCallBack={cancelProcessCallBack}
          />
        </div>
      ) : (
        <div className="work-cont-con">
          <Row gutter={[50, 0]}>
            <Col sm={12} span={24}>
              <div className="opr-item" id="video-compress-quality">
                <span className="label" style={{ marginBottom: "42px" }}>
                  {t("Quality")}
                </span>
                <Slider
                  marks={qulityMarks}
                  min={10}
                  max={100}
                  step={1}
                  value={quality}
                  tooltipVisible={true}
                  tipFormatter={value => value + "%"}
                  getTooltipPopupContainer={() => document.querySelector("#video-compress-quality")}
                  onChange={handleChangeQuality}
                />
              </div>
            </Col>
            <Col sm={12} span={24}>
              <div className="opr-item" id="video-compress-frameRate">
                <span className="label" style={{ marginBottom: "42px" }}>
                  {t("Frame Rate")}
                </span>
                <Slider
                  marks={frameRateMarks}
                  min={5}
                  max={maxFrameRate}
                  step={1}
                  value={frameRate}
                  tooltipVisible={true}
                  tipFormatter={value => (value > maxFrameRate ? maxFrameRate + "FPS" : value + "FPS")}
                  getTooltipPopupContainer={() => document.querySelector("#video-compress-frameRate")}
                  onChange={handleChangeFrameRate}
                />
              </div>
            </Col>
          </Row>

          <div className="opr-item">
            <span className="label">{t("Resolution")}</span>
            <Select className="dark-select" dropdownClassName="dark-select-dropdown" value={resolution} onChange={handleChangeResolution}>
              <Option value="original">{t("Keep Resolution")}</Option>
              {resolutionList
                .filter(item => item.value <= videoCompressObj.width * videoCompressObj.height)
                .map(item => (
                  <Option key={item.key} value={item.rule}>
                    {item.key}
                  </Option>
                ))}
            </Select>
          </div>
          <div className="opr-item">
            <span className="label">{t("Format")}</span>
            <Select className="dark-select" dropdownClassName="dark-select-dropdown" defaultValue="mp4">
              <Option value="mp4">MP4</Option>
            </Select>
          </div>
          <Button type="primary" size="large" onClick={handleSubmit}>
            {t("Compress")}
          </Button>
        </div>
      )}
    </div>
  );
};

export default VideoCompressWorkContentRender;
